import { useEffect } from 'react';
import axios, { InternalAxiosRequestConfig } from 'axios';
import { getAccessToken } from '../token/UserToken';

export const useAuthInterceptor = () => {
  useEffect(() => {
    // Interceptor simplificado apenas para adicionar token
    // O refresh é tratado pelo interceptor do api.tsx
    const requestInterceptor = axios.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        const token = getAccessToken();
        
        if (token && config.headers) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    // Cleanup function
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
    };
  }, []);
};
